import { render } from "./ClientsTableNew.vue?vue&type=template&id=3b1c1251&scoped=true"
import script from "./ClientsTableNew.vue?vue&type=script&lang=js"
export * from "./ClientsTableNew.vue?vue&type=script&lang=js"

import "./ClientsTableNew.vue?vue&type=style&index=0&id=3b1c1251&scoped=true&lang=css"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1c1251"]])

export default __exports__